import React from 'react'
import DOMPurify from 'dompurify'

import './styles.css'

const defaultOptions = {
  ALLOWED_TAGS: [ 'b', 'i', 'em', 'strong', 'a', 'br', 'p', 'ul', 'li' ],
  ALLOWED_ATTR: ['href']
}

const sanitize = (dirty: string) => ({
  __html: DOMPurify.sanitize(
    dirty,
    { ...defaultOptions, ...defaultOptions }
  )
})

type Props = { html: string }
const SanitizeHTML: React.FC<Props> = ({ html }) => (
  <div dangerouslySetInnerHTML={sanitize(html)} className='sanitize-html' />
)

export default SanitizeHTML
